export default "__VITE_ASSET__4ZksyliT__"